(function () {
  if (!window.location.pathname.endsWith('/collections/drills')) {
    return;
  }

  const grid = document.getElementById('product-grid');
  if (!grid) {
    return;
  }

  const items = grid.querySelectorAll('.grid__item[data-ovs-drill-type]');
  const pagination = document.querySelector('.pagination-wrapper');

  function parseList(param) {
    const raw = new URLSearchParams(window.location.search).get(param);
    if (!raw) {
      return [];
    }

    return raw
      .split(',')
      .map((value) => value.trim())
      .filter((value) => value !== '');
  }

  function selectedTypes() {
    return [...document.querySelectorAll('.ovs-drill-type-input:checked')]
      .map((input) => input.dataset.ovsDrillType || '')
      .filter((value) => value !== '');
  }

  function syncCheckboxLabels() {
    document.querySelectorAll('.ovs-drill-type-input').forEach((input) => {
      const label = input.closest('.ovs-drill-type-option');
      if (label) {
        label.classList.toggle('active', input.checked);
      }
    });
  }

  function syncCheckboxesFromUrl() {
    const types = parseList('ovs_drill_type');

    document.querySelectorAll('.ovs-drill-type-input').forEach((input) => {
      const type = input.dataset.ovsDrillType || '';
      input.checked = types.includes(type);
    });

    syncCheckboxLabels();
  }

  function buildUrl(types) {
    const url = new URL(window.location.href);
    url.searchParams.delete('ovs_drill_type');
    url.searchParams.delete('page');

    if (types.length > 0) {
      url.searchParams.set('ovs_drill_type', types.join(','));
    }

    return url;
  }

  function updateProductCount(visibleCount) {
    const countNodes = document.querySelectorAll(
      '#ProductCountDesktop, #ProductCountMobile, .product-count__text span',
    );
    countNodes.forEach((node) => {
      if (visibleCount === 1) {
        node.textContent = '1 product';
      } else {
        node.textContent = visibleCount + ' products';
      }
    });
  }

  function togglePagination(types) {
    if (!pagination) {
      return;
    }

    pagination.hidden = types.length > 0;
  }

  function applyFilters(updateHistory) {
    const types = selectedTypes();
    let visibleCount = 0;

    items.forEach((item) => {
      const itemType = item.dataset.ovsDrillType || '';
      let show = true;

      if (types.length > 0) {
        show = itemType !== '' && types.includes(itemType);
      }

      item.hidden = !show;
      if (show) {
        visibleCount += 1;
      }
    });

    syncCheckboxLabels();
    updateProductCount(visibleCount);
    togglePagination(types);

    if (updateHistory) {
      const url = buildUrl(types);
      window.history.pushState({ ovsDrillFilters: true }, '', url.pathname + url.search);
    }
  }

  document.querySelectorAll('.ovs-drill-type-input').forEach((input) => {
    input.addEventListener('change', () => {
      applyFilters(true);
    });
  });

  window.addEventListener('popstate', () => {
    syncCheckboxesFromUrl();
    applyFilters(false);
  });

  syncCheckboxesFromUrl();
  applyFilters(false);
})();
